import {Injectable} from '@angular/core';
import {DefaultDataServiceConfig, Logger} from '@ngrx/data';
import {HttpClient} from '@angular/common/http';
import {AbstractDataServiceV2} from '../../../../../core/service/v2/dataservice/abstractDataServiceV2';
import {CustomizeHttpUrlGenerator} from '../../../../../../store/core/url/customizeHttpUrlGenerator';
import {MedicalReportModel} from '../../../api/entity/medicalReport.model';
import {MedicalReportConverter} from '../../../api/entity/medicalReport.converter';

@Injectable()
export class MedicalReportDataService extends AbstractDataServiceV2<MedicalReportModel, MedicalReportConverter> {
    constructor(http: HttpClient,
                httpUrlGenerator: CustomizeHttpUrlGenerator,
                logger: Logger,
                config: DefaultDataServiceConfig,
                converter: MedicalReportConverter) {
        super('MedicalReport', http, httpUrlGenerator, logger, config, converter);
    }
}
